import { getController, postController } from '@/controllers/request';

const getDefaultParams = url => {
  let params = {};
  //Добавляем дефолтные параметры для открытия
  url
    .split('?')[1]
    .split('&')
    .map(param => {
      if (!param.split('=')[1]) return;
      params[param.split('=')[0]] = param.split('=')[1];
    });
  // Добавляем дефолтные параметры для сохранения

  return params;
};
export default {
  namespaced: true,
  state: {
    datepicker: {
      dateFormat: '',
      timeFormat: 'HH:mm'
    },
    vacancySkillsData: {},
    templateVacancyForm: {},
    visibility_blocked: {},
    sapHelps: {},
    initialSendRequests: [],
    etalonForm: {}, // for dynamic request
    cleanFieldSchema: {},
    fieldKey: 0,
    hiddenPanels: [],
    metadata: {},
    exitAlert: false,
    recognisedForm: null,
    loading: false,
    saveIntents: null,
    isResetAddress: false
  },
  mutations: {
    setDatePicker(state, value) {
      state.datepicker = value;
    },
    setExitAlert(state, value) {
      state.exitAlert = value;
    },
    setLoading(state, value) {
      state.loading = value;
    },
    setDateFormat(state, value) {
      let newdateformat = value;
      if (
        newdateformat.indexOf('mm') &&
        newdateformat[newdateformat.indexOf('m')] === 'm'
      ) {
        newdateformat = newdateformat.replace(/m/g, 'M');
      }
      state.datepicker.dateFormat = newdateformat;
    },
    setTemplateVacancyForm(state, { payload, fields }) {
      // новое условие из задачи HRCRMSM-919: не перезаписывать на пустые значения
      if (payload == null) {
        state.templateVacancyForm = payload;
        return;
      }

      for (let key in payload) {
        const val = payload[key];

        if (val === '') continue;
        if (Array.isArray(val) && !val.length) continue;
        if (
          typeof val == 'object' &&
          !Array.isArray(val) &&
          !val?.id &&
          !val?.value &&
          fields[key]?.type !== 'rellink'
        ) {
          continue;
        }
        if (fields[key]?.type == 'bool' && val == '0') continue;

        state.templateVacancyForm[key] = val;
      }
    },
    setVacancySkills(state, skills) {
      state.vacancySkillsData = skills;
    },
    setMetadata(state, metadata) {
      state.metadata = metadata;
    },
    setRecognisedForm(state, form) {
      state.recognisedForm = form;
    },
    setIntents(state, intents) {
      state.saveIntents = intents;
    },
    setEtalonForm(state, data = {}) {
      state.etalonForm = { ...state.etalonForm, ...data };
    },
    setBlocked(state, { key, val }) {
      state.visibility_blocked = { ...state.visibility_blocked, [key]: val };
    },
    setSapHelp(state, { key, val }) {
      state.sapHelps = { ...state.sapHelps, [key]: val };
    },
    setInitialDynamicRequest(state, data = {}) {
      if (data.field && data.value) state.initialSendRequests.push(data);
    },
    setEmptyInitialDynamicRequest(state) {
      state.initialSendRequests = [];
    },
    setCleanFieldSchema(state, data = {}) {
      for (let key in data) {
        if (state.cleanFieldSchema[key]?.length)
          state.cleanFieldSchema[key].push(...data[key]);
        else state.cleanFieldSchema[key] = data[key];
      }
    },
    updateKey(state) {
      state.fieldKey++;
    },
    setHiddenPanelLabel(state, data) {
      if (data.val) {
        state.hiddenPanels.push(data.lbl);
      } else {
        state.hiddenPanels = state.hiddenPanels.filter(el => el !== data.lbl);
      }
    },
    resetAddress(state, reset = false) {
      state.isResetAddress = reset;
    }
  },
  actions: {
    async getMetadata(
      { commit },
      { id = '', module, action = 'get_editView', request = {}, url = '' }
    ) {
      commit('setLoading', true);
      if (url.length) {
        const params = getDefaultParams(url);
        try {
          const response = await getController({
            url: request?.url || '',
            params: params
          });
          commit('setMetadata', response?.data);

          if (response?.data?.user_dat_format) {
            commit('setDateFormat', response.data.user_dat_format);
          }

          if (response?.data?.exit_alert) {
            commit('setExitAlert', response.data.exit_alert);
          }

          if (response?.data?.bean && !Object.keys(this.fields).length) {
            this.fields = { ...response.data.bean };
          }

          if (response.data?.bean?.id.value) {
            return true;
          } else {
            return false;
          }
        } catch (e) {
          console.error(e);
        } finally {
          commit('setLoading', false);
        }
        return;
      }
      let params =
        request?.request_params && Object.keys(request?.request_params).length
          ? { ...request.request_params }
          : {
              module: module,
              action: action,
              record: id
            };
      try {
        const response = await getController({
          url: request?.url || '',
          params: params
        });
        commit('setMetadata', response?.data);

        if (response?.data?.user_dat_format) {
          commit('setDateFormat', response.data.user_dat_format);
        }

        if (response?.data?.exit_alert) {
          commit('setExitAlert', response.data.exit_alert);
        }

        if (response.data?.bean?.id.value) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        console.error(e);
      } finally {
        commit('setLoading', false);
      }
    },
    async loadVacancyTemplateData(
      { commit, dispatch, rootState },
      { id, module, fields }
    ) {
      if (id && !rootState.common.requestSent) {
        rootState.common.requestSent = true;

        try {
          const request = await getController({
            params: {
              module,
              action: 'fillVacancyFields',
              vacancy_template_id: id,
              to_pdf: true
            }
          });

          commit('setTemplateVacancyForm', { payload: request.data, fields });
        } catch (err) {
          dispatch(
            'common/catchError',
            {
              err,
              msg: 'Возникла ошибка при получении данных шаблона вакансии',
              action: 'get vacancy template data'
            },
            { root: true }
          );
        }
        rootState.common.requestSent = false;
      }
    },
    async addNewSkill({ commit, dispatch }, { name, skills, type }) {
      const formData = new FormData();

      formData.set('module', 'HRPAC_SKILLS');
      formData.set('action', 'create_skill');
      formData.set('skill_type', type);
      formData.set('skill_name', skills[name]);
      formData.set('to_pdf', true);
      formData.set('jsqon_return', 1);

      try {
        const request = await postController({ options: formData });

        if (request.data) {
          commit('setVacancySkills', request.data);
        }
      } catch (err) {
        dispatch(
          'common/catchError',
          {
            err,
            msg: 'Возникла ошибка при создании новых навыков',
            action: 'create new skill'
          },
          { root: true }
        );
      }
    },
    async addNewOption({ commit, dispatch }, { name, skills }) {
      const formData = new FormData();

      formData.set('module', 'HRPAC_VACANCY_NAMES');
      formData.set('action', 'createVacancyNames');
      formData.set('vacancy_name', skills[name]);
      formData.set('to_pdf', true);

      try {
        const request = await postController({ options: formData });

        if (request.data) {
          commit('setVacancySkills', request.data?.vacancy_id);
        }
      } catch (err) {
        dispatch(
          'common/catchError',
          {
            err,
            msg: 'Возникла ошибка при создании новой опции',
            action: 'create new option'
          },
          { root: true }
        );
      }
    },
    async saveForm(ctx, data = {}) {
      // передаем параметры запроса
      const options = new FormData();

      for (let key in data) {
        if (Array.isArray(data[key])) {
          data[key].forEach(item => options.append(`${key}[]`, item));
        } else options.append(key, data[key]);
      }

      try {
        await postController({
          options,
          params: {
            header: {
              'Content-Type': 'multipart/form-data'
            }
          }
        });
      } catch (e) {
        console.error(e);
      }
    }
  }
};
